import Navbar from "../../../component/navbar";
import Footer from "../../../component/footer";

export default function Academic1() {
  return (
    <>
      <Navbar />
      <div className="relative">
        <div className=" bg-gradient-to-b from-gray-100 to-gray-50 h-screen md:h-full">
          <div className="container mx-auto max-w-5xl py-[100px] md:py-[150px] px-10 sm:px-20 md:px-0  ">
            <div className="text-2xl md:text-3xl font-[900] mb-8 text-gray-600">
              ขั้นตอนการขอตำแหน่งทางวิชาการ
            </div>
            {/* banner section */}
            <div className="my-5 shadow-md rounded-lg overflow-hidden">
              <div className="bg-fixed sm:bg-local overflow-y-auto h-full w-full custom-scrollbar">
                <img
                  className="object-cover w-full h-full"
                  src="/STEP/02.jpg"
                  alt="not img"
                />
              </div>
            </div>
            {/* banner section */}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
